import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import SignupFilters from './SignupFilters';
import SignupRow from './SignupRow';
import PaginationFooter from '../../components/PaginationFooter';

const HEADERS = [
  { label: 'Nome', align: 'left' },
  { label: 'E-mail', align: 'left' },
  { label: 'Empresa', align: 'left' },
  { label: 'Telefone', align: 'left' },
  { label: 'Cadastro', align: 'left' },
  { label: 'Último envio', align: 'left' },
  { label: 'Validade', align: 'left' },
  { label: 'Ações', align: 'right' },
];

/**
 * SignupsTable - Filtros, tabela e paginação server-side dos cadastros pendentes
 * (Admin Geral > Cadastros pendentes)
 * @param {Object} props
 * @param {Array} props.signups
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Object} props.pagination
 * @param {Object} props.filters - props repassadas ao SignupFilters
 * @param {Function} props.onPageChange
 * @param {Function} props.onResend
 * @param {number|null} props.resendingId
 */
function SignupsTable({
  signups = [],
  isLoading = false,
  error = null,
  pagination,
  filters,
  onPageChange,
  onResend,
  resendingId,
}) {
  const hasActiveFilters = Boolean((filters?.status && filters.status !== 'all') || filters?.searchInput);

  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      <SignupFilters {...filters} />

      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : signups.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    {hasActiveFilters ? 'Nenhum cadastro com esses filtros' : 'Nenhum cadastro pendente'}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              signups.map((signup) => (
                <SignupRow
                  key={signup.id}
                  signup={signup}
                  onResend={onResend}
                  isResending={resendingId === signup.id}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationFooter pagination={pagination} onPageChange={onPageChange} itemLabel="cadastros" />
    </Paper>
  );
}

export default SignupsTable;
